import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledPanelTitle = styled.h3`
    ${mixins.setFontVariant("button", colorsPalettes.carbon["500"])};

    line-height: 20px;
    margin: 0;
    text-transform: capitalize;
    user-select: none;
`;
